import { useContentfulMultipleEntry } from '../../hooks/useContentfulMultipleEntry';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import CallToAction from '../widgets/CallToAction';

function Hero(props) {
  const { section, zIndex, minHeight } = props;
  const items = section?.fields?.items || [];
  const { entries, loading, error } = useContentfulMultipleEntry(items);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading hero content.</div>;
  if (!entries || entries.length === 0) return null;

  const hero = entries[0];
  if (!hero || !hero.fields) return null;


  let internalLink = hero.fields.callToActionArticle && hero.fields.callToActionArticle.fields && hero.fields.callToActionArticle.fields.url
    ? hero.fields.callToActionArticle.fields.url
    : false;
  if (!internalLink && hero.fields.callToActionArticle) {
    internalLink = "/article/" + hero.sys.id;
  }
  let externalLink = hero.fields.callToActionUrl
    ? hero.fields.callToActionUrl
    : false;

  return (
    <Container
      id="hero"
      fluid
      style={{
        backgroundImage: hero.fields.image && hero.fields.image.fields && hero.fields.image.fields.file
          ? `url(${hero.fields.image.fields.file.url})`
          : undefined,
        minHeight: minHeight ?? 500,
        zIndex: zIndex,
      }}
    >
      <Row className="lp" style={{ marginLeft: -20, marginTop: 140 }}>
        <Col lg={12} md={12}>
          <h1>{hero.fields.headline}</h1>
          <p className="tagline">{hero.fields.tagline}</p>
          {hero.fields.displayCallToAction && (
            <CallToAction internalLink={internalLink} externalLink={externalLink}>
              <i className="fas fa-arrow-right"></i> {hero.fields.callToAction}
            </CallToAction>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Hero;
